import React from 'react';
import fr from 'facet-rest';
import {
  FDBodyText,
  FDLozenge,
  FDTableCell,
  FDTableRow,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import classNames from 'classnames';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { getDynamicDateTypeValue } from 'Components/Universal/Questionnaire/utils';
import { generalDate } from 'Consts/DateFormats';

const useStyles = buildUseStyles('GuidedHouseholdReviewDateTableLineItemLayout', () => ({
  wrapper: {
    display: 'flex',
    flex: 1,
  },
  bold: {
    '& > * > * > *': {
      fontWeight: '500 !important', // Needs to be !important to overwrite FD to match the figma
    },
    '& > * > *': {
      fontWeight: '500 !important', // Needs to be !important to overwrite FD to match the figma
    },
  },
}));

export const GuidedHouseholdReviewDateTableLineItemLayout = () => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();
  const { loadModalCollectionByLink } = useModalContext();

  const handleRowClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const rel = resource.withRelationship(fr.relationships.edit.name);
    if (rel) {
      loadModalCollectionByLink(rel.link('related').url());
    }
  };
  const hasHover = resource.withRelationship(fr.relationships.edit.name, () => { return true; }, () => { return false; });

  const boldWrapper = (children) => (
    <div className={classNames(classes.wrapper, { [classes.bold]: resource.attr('bold') === 'true' })}>{children}</div>
  );

  // This is a hack to get the start and end date values to display in the table.
  // These values for these fields are driven by excludedUnless logic, but that isn't supported here
  const { key: startKey, value: startValue } = getDynamicDateTypeValue(resource, 'start', generalDate);
  const { key: endKey, value: endValue } = getDynamicDateTypeValue(resource, 'end', generalDate);

  return (
    <FDTableRow onClick={handleRowClick} hover={hasHover}>
      <FDTableCell>
        {boldWrapper(
          <>
            {resource.attr('tag') && (
            <FDLozenge color="info" label={resource.attr('tag')} size="sm" />
            )}
            <MetaControlField attr={'name'} />
          </>,
        )}
      </FDTableCell>
      <FDTableCell>
        {boldWrapper(
          <MetaControlField attr={'amountWithFrequency'} />,
        )}
      </FDTableCell>
      <FDTableCell>
        {boldWrapper(
          <FDBodyText key={startKey} value={startValue} />,
        )}
      </FDTableCell>
      <FDTableCell>
        {boldWrapper(
          <FDBodyText key={endKey} value={endValue} />,
        )}
      </FDTableCell>
    </FDTableRow>
  );
};

GuidedHouseholdReviewDateTableLineItemLayout.propTypes = {};
